import { useRouteLoaderData } from 'react-router'

import { ProductPageLoaderData } from '~/routes/_docs.$productname/loader'
import { PORTAL_PRODUCT_ROLE } from '~/types/portal'
import { LandingProduct } from '~/types/product'

export const useProducts = (): {
  currentProduct?: LandingProduct,
  products: LandingProduct[],
  productSlug?: string,
  currentProductRole?: PORTAL_PRODUCT_ROLE,
} => {
  const loaderData = useRouteLoaderData<ProductPageLoaderData>('routes/_docs.$productname/_index')
  const currentProduct = loaderData?.currentProduct
  const products = loaderData?.products || []
  const productSlug = loaderData?.productSlug
  const currentProductRole = loaderData?.currentProductRole

  return { currentProduct, currentProductRole, products, productSlug }
}